import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../config/connect";

const PerformanceFeatures = ({ onPerformanceFeaturesSelected }) => {
  const [selectedPerformanceFeatures, setSelectedPerformanceFeatures] =
    useState(null);
  const [variations, setVariations] = useState([]);
  const { prodcode } = useParams();

  const getAllProductVariations = async () => {
    try {
      const response = await fetch(
        `https://ghmarkets.net/test/ghmarketconnect/?ghw=productservices&svg=fashionvariations&prcode=${prodcode}`
      );
      const json = await response.json();
      const firstResult = json["results"][0];
      if (firstResult && firstResult.performancefeatures) {
        const performanceFeaturesObject = firstResult.performancefeatures;
        if (performanceFeaturesObject.trim() !== "") {
          setVariations(performanceFeaturesObject.split(","));
        }
      }
    } catch (error) {
      // Handle error here
    }
  };

  useEffect(() => {
    getAllProductVariations();
  }, [prodcode]);

  const handlePerformanceFeaturesClick = (performancefeatures) => {
    setSelectedPerformanceFeatures(performancefeatures);
    onPerformanceFeaturesSelected(performancefeatures);
  };

  return variations.length > 0 ? (
    <div
      className="sizes-container"
      style={{ display: "flex", flexDirection: "row" }}
    >
      <span
        style={{
          fontSize: "",
          fontWeight: "bold",
          color: "black",
          marginTop: "12px",
        }}
      >
        Performance Features:
      </span>
      <div className="sizes">
        {variations.map((variation, i) => (
          <div
            key={i}
            className={`size ${selectedPerformanceFeatures === variation ? "selected" : ""}`}
            onClick={() => handlePerformanceFeaturesClick(variation)}
          >
            {variation}
          </div>
        ))}
      </div>
    </div>
  ) : (
    ""
  );
};

export default PerformanceFeatures;
